import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import add from 'ramda/es/add';
import compose from 'ramda/es/compose';
import length from 'ramda/es/length';
import multiply from 'ramda/es/multiply';
import { List } from 'immutable';
import { WindowListener } from '../../windowListener/windowListener.component';
import { getField } from '../../../utils/cmsData';
import { PlatformDetector } from '../../platformDetector/platformDetector.component';

export class ClipItemsToWrapper extends PureComponent {
  static propTypes = {
    wrapper: PropTypes.any.isRequired,
    items: PropTypes.instanceOf(List).isRequired,
    children: PropTypes.func.isRequired,
  };

  state = {
    maxWidth: window.innerWidth,
  };

  componentDidMount() {
    setTimeout(this.measure);
  }

  sliceItems() {
    const linkwidths = this.props.items.map(compose(
      add(16),
      multiply(9),
      length,
      getField('name')
    ));

    const reduced = linkwidths.toJS().reduce((acc, linkWidth) => {
      if (acc.totalWidth + linkWidth >= this.state.maxWidth || acc.done) {return { ...acc, done: true };}

      return {
        length: acc.length + 1,
        totalWidth: acc.totalWidth + linkWidth,
      };
    }, { length: 0, totalWidth: 0, done: false });
    return this.props.items.slice(0, reduced.length);
  }

  measure = () => {
    const maxWidth = this.props.wrapper.current ? this.props.wrapper.current.offsetWidth : 9999;
    this.setState({ maxWidth });
  };

  render() {
    return (
      <Fragment>
        <WindowListener handledFunction={this.measure} eventType={'resize'} throttleValue={250} />
        <PlatformDetector>
          {({ isMobile }) => this.props.children(isMobile ? this.sliceItems() : this.props.items)}
        </PlatformDetector>
      </Fragment>
    );
  }
}
